import styled from "styled-components";
import theme from "../../../../Styles/theme";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 60%;
  margin: auto;
`;

export const ContainertInput = styled.div`
  width: 100%;
  margin-top: 1vh;
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  width: 100%;
  font-size: max(1vw, 10px);
  color: ${theme.colors.dark};
  font-weight: bold;
`;
export const Input = styled.input`
  width: 100%;
  background: ${theme.colors.light};
  border: none;
  color: ${theme.colors.dark};
  font-size: max(1vw, 10px);
  padding: 1vh 2vw;
  border-radius: 0.25rem;
`;

export const Button = styled.button`
  
  background-color: ${theme.colors.darkGrey};
  font-size: max(1vw, 10px);
  font-weight: bold;
  color: ${theme.colors.dark};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  margin: auto;
  margin-top: 1vh;
  &:hover {
    opacity: 0.7;
  }
`;
